import "../css/footer.css";

export default function Footer() {
	return (
		<div className="bottom-container">
			<a
				className="footer-link"
				href="https://www.linkedin.com/in/sophie-chai-9115ba161/"
			>
				LinkedIn
			</a>
			<a
				className="footer-link"
				href="https://www.facebook.com/chaisuefei.sophie"
			>
				Facebook
			</a>
			<p className="copyright">© 2022 Sophie Chai.</p>
		</div>
	);
}
